import api from './index';

export const tripsApi = {
  getAll: async (params = {}) => {
    const response = await api.get('/trips', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/trips/${id}`);
    return response.data;
  },

  updateStatus: async (id, toStatus, note) => {
    // Map status strings to idEstatus numbers
    const statusMap = {
      'PENDIENTE_INICIAR': 0,     // Pendiente de iniciar
      'EN_CAMINO_SALIDA': 1,      // En tránsito a dirección origen
      'ESPERA_SALIDA': 2,         // Llegada a dirección origen
      'CONTACTO_SOLICITANTE': 3,  // Contacto con solicitante
      'EN_RUTA': 4,               // Inicio del viaje
      'EN_TRANSITO_DESTINO': 5,   // En tránsito a destino
      'EN_DESTINO': 6,            // Llegada a destino
      'FINALIZADO': 7             // Finalización del servicio
    };

    const idEstatus = statusMap[toStatus] || parseInt(toStatus);
    const response = await api.post(`/trips/${id}/estatus`, { idEstatus });
    return response.data;
  },

  getHistory: async (id) => {
    const response = await api.get(`/trips/${id}/history`);
    return response.data;
  },

  getAssignment: async (id) => {
    const response = await api.get(`/trips/${id}/assignment`);
    return response.data;
  },

  createAssignment: async (id, data) => {
    const response = await api.post(`/trips/${id}/assignment`, data);
    return response.data;
  },

  getCalendar: async (params = {}) => {
    const response = await api.get('/trips/calendar', { params });
    return response.data;
  },

  // New unified endpoints
  reject: async (id, data) => {
    const response = await api.post(`/trips/${id}/reject`, data);
    return response.data;
  },

  assign: async (id, data) => {
    // Transform data to match API structure
    const payload = {
      driverId: data.driver_id || data.driverId,
      vehicleId: data.vehicle_id || data.vehicleId
    };
    const response = await api.post(`/trips/${id}/assign`, payload);
    return response.data;
  },

  updateEstatus: async (id, data) => {
    // Transform data to match API structure
    const payload = {
      idEstatus: data.idEstatus || data.id_estatus || data.toStatus
    };
    // If toStatus is a string, map it to number
    if (typeof payload.idEstatus === 'string') {
      const statusMap = {
        'PENDIENTE_INICIAR': 0,
        'EN_CAMINO_SALIDA': 1,
        'ESPERA_SALIDA': 2,
        'CONTACTO_SOLICITANTE': 3,
        'EN_RUTA': 4,
        'EN_TRANSITO_DESTINO': 5,
        'EN_DESTINO': 6,
        'FINALIZADO': 7
      };
      payload.idEstatus = statusMap[payload.idEstatus] || parseInt(payload.idEstatus);
    }
    const response = await api.post(`/trips/${id}/estatus`, payload);
    return response.data;
  },

  reassign: async (id, data) => {
    // Transform data to match API structure
    const payload = {
      driverId: data.driver_id || data.driverId,
      vehicleId: data.vehicle_id || data.vehicleId,
      clMotivoReasignacion: parseInt(data.clMotivoReasignacion || data.motivo_reasignacion)
    };
    const response = await api.post(`/trips/${id}/reassign`, payload);
    return response.data;
  },
};

